export class PaymentPost {

  constructor() {
    this.amount = '';
    this.cardNumber = '';
    this.month = '';
    this.year = '';
    this.cardSecurityCode = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.address = '';
    this.city = '';
    this.zip = '';
    this.itemId = '';
    this.classname = '';
    this.quantity = '1';
    this.unitPrice = '';
  }

  amount: string;
  cardNumber: string;
  month: string;
  year: string;
  cardSecurityCode: string;
  firstName: string;
  middleName: string;
  lastName: string;
  address: string;
  city: string;
  zip: string;
  itemId: string;
  classname: string;
  quantity: string;
  unitPrice: string;
}



// WEBPACK FOOTER //
// ./src/app/models/payment-post.ts